import type { ConditionRule } from './moving-item.types';

/** 타입별로 허용 필드만 남김 (스프레드 병합 시 이전 AND/CROSS_AND 필드 제거) */
export function sanitizeConditionRule(rule: ConditionRule): ConditionRule {
  switch (rule.type) {
    case 'CROSS_AND':
      return { type: 'CROSS_AND', clauses: rule.clauses ?? [] };
    case 'AND':
      return { type: 'AND', rules: rule.rules ?? [] };
    case 'NUMBER_GTE':
    case 'NUMBER_GT':
    case 'NUMBER_LTE':
    case 'NUMBER_LT':
      return { type: rule.type, threshold: rule.threshold };
    case 'BOOLEAN_EQ':
      return { type: 'BOOLEAN_EQ', value: rule.value };
    case 'ENUM_IN':
      return { type: 'ENUM_IN', values: rule.values };
    default:
      return { type: rule.type };
  }
}

/** UI 기본값 포함 정규화 (빈 AND/CROSS_AND 보정) */
export function normalizeRuleForType(rule: ConditionRule): ConditionRule {
  if (rule.type === 'CROSS_AND') {
    const clauses = rule.clauses?.length
      ? rule.clauses
      : [{ key: '', rule: { type: 'ALWAYS_MATCH' as const } }];
    return { type: 'CROSS_AND', clauses };
  }
  if (rule.type === 'AND') {
    const rules = rule.rules?.length
      ? rule.rules
      : [{ type: 'ALWAYS_MATCH' as const }, { type: 'ALWAYS_MATCH' as const }];
    return { type: 'AND', rules };
  }
  return sanitizeConditionRule(rule);
}
